/**
 * Set the debug mode for the application
 * @param {boolean} debug
 */
export const setDebugMode = (debug: boolean): void => {
  localStorage.setItem("ctra.debug", debug ? "true" : "false");
};

/**
 * Check if the application is in debug mode
 * @returns {boolean}
 */
export const isDebugMode = (): boolean => {
  const debug = localStorage.getItem("ctra.debug");

  return debug === "true";
};
